const permissionColumns = [
  {
    headerName: 'RolesManagement.RolesColumn.Read',
    headerTooltip: 'RolesManagement.RolesColumn.Read',
    field: 'permission',
    colId: 'read',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.read,
    cellRendererParams: {
      permissionType: {
        id: 'read'
      }
    }
  },
  {
    headerName: 'RolesManagement.RolesColumn.Create',
    headerTooltip: 'RolesManagement.RolesColumn.Create',
    field: 'permission',
    colId: 'create',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.create,
    cellRendererParams: {
      permissionType: {
        id: 'create'
      }
    }
  },
  {
    headerName: 'RolesManagement.RolesColumn.Update',
    headerTooltip: 'RolesManagement.RolesColumn.Update',
    field: 'permission',
    colId: 'update',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.update,
    cellRendererParams: {
      permissionType: {
        id: 'update'
      }
    }
  },
  {
    headerName: 'RolesManagement.RolesColumn.Delete',
    headerTooltip: 'RolesManagement.RolesColumn.Delete',
    field: 'permission',
    colId: 'delete',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.delete,
    cellRendererParams: {
      permissionType: {
        id: 'delete'
      }
    }
  },
  {
    headerName: 'RolesManagement.RolesColumn.Import',
    headerTooltip: 'RolesManagement.RolesColumn.Import',
    field: 'permission',
    colId: 'import_',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.import_,
    cellRendererParams: {
      permissionType: {
        id: 'import_'
      }
    }
  },
  {
    headerName: 'RolesManagement.RolesColumn.Export',
    headerTooltip: 'RolesManagement.RolesColumn.Export',
    field: 'permission',
    colId: 'export',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.export,
    cellRendererParams: {
      permissionType: {
        id: 'export'
      }
    }
  }
]

export const instancesColumn = [
  {
    headerName: 'RolesManagement.InstancesColumn.Id',
    headerTooltip: 'RolesManagement.InstancesColumn.Id',
    field: 'id',
    filter: 'agTextColumnFilter',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressSizeToFit: true,
    pinned: 'left',
    lockPinned: true,
    lockVisible: true,
    hide: true
  },
  {
    checkboxSelection: true,
    headerName: 'RolesManagement.InstancesColumn.Name',
    headerTooltip: 'RolesManagement.InstancesColumn.Name',
    field: 'title',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.InstancesColumn.Role',
    headerTooltip: 'RolesManagement.InstancesColumn.Role',
    field: 'roleName',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  ...permissionColumns
]

export const workingTableColumn = [
  {
    headerName: 'RolesManagement.WorkingTablesColumn.Id',
    headerTooltip: 'RolesManagement.WorkingTablesColumn.Id',
    field: 'id',
    filter: 'agTextColumnFilter',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressSizeToFit: true,
    pinned: 'left',
    lockPinned: true,
    lockVisible: true,
    hide: true
  },
  {
    headerName: 'RolesManagement.WorkingTablesColumn.Name',
    headerTooltip: 'RolesManagement.WorkingTablesColumn.Name',
    field: 'title',
    hide: false,
    filter: 'agTextColumnFilter',
    checkboxSelection: true
  },
  {
    headerName: 'RolesManagement.WorkingTablesColumn.Instance',
    headerTooltip: 'RolesManagement.WorkingTablesColumn.Instance',
    field: 'instanceTitle',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.WorkingTablesColumn.Role',
    headerTooltip: 'RolesManagement.WorkingTablesColumn.Role',
    field: 'roleName',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  ...permissionColumns
]

export const documentTypeColumn = [
  {
    headerName: 'RolesManagement.DocumentTypesColumn.Id',
    headerTooltip: 'RolesManagement.DocumentTypesColumn.Id',
    field: 'id',
    filter: 'agTextColumnFilter',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressSizeToFit: true,
    pinned: 'left',
    lockPinned: true,
    lockVisible: true,
    hide: true
  },
  {
    headerName: 'RolesManagement.DocumentTypesColumn.Type',
    headerTooltip: 'RolesManagement.DocumentTypesColumn.Type',
    field: 'title',
    hide: false,
    filter: 'agTextColumnFilter',
    checkboxSelection: true
  },
  {
    headerName: 'RolesManagement.DocumentTypesColumn.Instance',
    headerTooltip: 'RolesManagement.DocumentTypesColumn.Instance',
    field: 'instanceTitle',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.DocumentTypesColumn.WorkingTable',
    headerTooltip: 'RolesManagement.DocumentTypesColumn.WorkingTable',
    field: 'workingTableTitle',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.DocumentTypesColumn.Role',
    headerTooltip: 'RolesManagement.DocumentTypesColumn.Role',
    field: 'roleName',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  ...permissionColumns
]

export const documentFieldColumn = [
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.Id',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.Id',
    field: 'id',
    filter: 'agTextColumnFilter',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressSizeToFit: true,
    pinned: 'left',
    lockPinned: true,
    lockVisible: true,
    hide: true
  },
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.Name',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.Name',
    field: 'title',
    hide: false,
    filter: 'agTextColumnFilter',
    cellRenderer: 'agGroupCellRenderer',
    checkboxSelection: true
  },
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.Instance',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.Instance',
    field: 'instanceTitle',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.WorkingTable',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.WorkingTable',
    field: 'workingTableTitle',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.DocumentTypesColumn.Type',
    headerTooltip: 'RolesManagement.DocumentTypesColumn.Type',
    field: 'documentType',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.Role',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.Role',
    field: 'roleName',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  ...permissionColumns
]

export const documentFieldChildColumn = [
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.Id',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.Id',
    field: 'id',
    filter: 'agTextColumnFilter',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressSizeToFit: true,
    pinned: 'left',
    lockPinned: true,
    lockVisible: true,
    hide: true
  },
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.Name',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.Name',
    field: 'title',
    hide: false,
    filter: 'agTextColumnFilter',
    checkboxSelection: true
  },
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.Instance',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.Instance',
    field: 'instanceTitle',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.WorkingTable',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.WorkingTable',
    field: 'workingTableTitle',
    hide: false,
    filter: 'agTextColumnFilter',
    cellStyle: { fontWeight: '900' }
  },
  {
    headerName: 'RolesManagement.DocumentTypesColumn.Type',
    headerTooltip: 'RolesManagement.DocumentTypesColumn.Type',
    field: 'documentType',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.DocumentFieldsColumn.Role',
    headerTooltip: 'RolesManagement.DocumentFieldsColumn.Role',
    field: 'roleName',
    hide: false,
    filter: 'agTextColumnFilter'
  },
  ...permissionColumns
]
